export function generateMailtoLink(to: string, subject: string, body: string): string {
  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);
  return `mailto:${to}?subject=${encodedSubject}&body=${encodedBody}`;
}

const supportEmail = 'support@example.com';
const subjectTemplate = 'Please help, I encountered an error when booking an appointment online';
const messageTemplate = (screenName: string, requestId: string): string => `Hello Skin Clique Support!
 
I received the below error when trying to book an appointment online: 
"An error occured in request ${requestId} on the ${screenName}."
 
(Please add any additional requests or details here!)`;

export function generateMailtoLinkForErrorOnScreen(screenName: string, requestId: string): string {
  return generateMailtoLink(supportEmail, subjectTemplate, messageTemplate(screenName, requestId));
}
